import { useFormikContext } from "formik";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { Channel } from "../../Channel";
import RadioGroup from "@mui/material/RadioGroup";
import Stack from "@mui/material/Stack";
import { CreateCampaignData } from "../../../types/campaign";

export function Channels() {
  const formik = useFormikContext<CreateCampaignData>();

  return (
    <Stack spacing={4}>
      <Typography color="primary">Canais</Typography>
      <RadioGroup
        value={formik.values.channel}
        aria-labelledby="demo-radio-buttons-group-label"
        name="radio-buttons-group"
        onChange={(_, value) => formik.setFieldValue("channel", value)}
      >
        <Grid container spacing={2}>
          <Grid display="flex" item xs={4}>
            <Channel
              value="sms"
              title="SMS"
              icon="sms"
              subtitle="Envie mensagens de SMS para seus contatos"
            />
          </Grid>
          <Grid display="flex" item xs={4}>
            <Channel
              value="whatsapp"
              title="WhatsApp"
              icon="whatsapp"
              subtitle="Envie mensagens de WhatsApp para seus contatos"
            />
          </Grid>
          <Grid display="flex" item xs={4}>
            <Channel
              value="email"
              title="Email"
              icon="email"
              subtitle="Envie mensagens de Email para seus contatos"
            />
          </Grid>
        </Grid>
      </RadioGroup>
    </Stack>
  );
}
